import React from "react";
import { Table } from "reactstrap";
import TablePaginationButtons from "./TablePaginationButtons";
import SortableTableHeader from "./SortableTableHeader";
import CreateOrderTableCells from "./CreateOrderTableCells";

const MonthlyOrdersTableByOrderView = ({
    orders,
    filterOrders,
    filters,
    orderPage,
    setOrderPage,
    pageSize,
    reloadTime,
    sortedOrders,
    setSortConfig
}) => {
    const user = JSON.parse(localStorage.getItem("authUser"));

    const allOrders = orders.flatMap((loc) =>
        filterOrders(loc.orders.map((o) => ({ ...o, locationName: loc.name })))
    );

    const totalOrders = allOrders.length;
    const paginatedOrders = sortedOrders(allOrders).slice(
        filters.pagination ? (orderPage - 1) * pageSize : 0,
        filters.pagination ? orderPage * pageSize : undefined
    );

    return (
        <>
            <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                <Table className="align-middle table-hover table-nowrap mb-0" responsive>
                    <SortableTableHeader
                        columns={[
                            { label: "Location" },
                            { label: "Date", sortKey: "date_created" },
                            { label: "Customer" },
                            { label: "Items" },
                            { label: "Payment Method" },
                            { label: "Status" },
                            { label: "Total" },
                            ...(filters.showBarcode ? [{ label: "Barcode" }] : []),
                            { label: "" },
                        ]}
                        onSort={setSortConfig}
                    />
                    <tbody>
                        {paginatedOrders.map((o) => (
                            <tr key={o.id}>
                                <td>{o.locationName}</td>
                                <CreateOrderTableCells
                                    o={o}
                                    filters={filters}
                                    user={user}
                                    reloadTime={reloadTime}
                                    showDelete={true}
                                    orders={orders}
                                    filterOrders={filterOrders}
                                    sortedOrders={sortedOrders}
                                    setSortConfig={setSortConfig}
                                />
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {filters.pagination && totalOrders > pageSize && (
                <TablePaginationButtons
                    currentPage={orderPage}
                    totalItems={totalOrders}
                    pageSize={pageSize}
                    onPageChange={setOrderPage}
                />
            )}
        </>
    );
};

export default MonthlyOrdersTableByOrderView;